var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31718 1.28967C8.69047 0.903442 9.30953 0.903443 9.68282 1.28967L11.4444 3.11236H13.938C14.4625 3.11236 14.8876 3.53752 14.8876 4.06198V6.55556L16.7103 8.31718C17.0966 8.69047 17.0966 9.30953 16.7103 9.68282L14.8876 11.4444V13.938C14.8876 14.4625 14.4625 14.8876 13.938 14.8876H11.4444L9.68282 16.7103C9.30953 17.0966 8.69047 17.0966 8.31718 16.7103L6.55555 14.8876H4.06198C3.53752 14.8876 3.11236 14.4625 3.11236 13.938V11.4444L1.28967 9.68282C0.903443 9.30953 0.903442 8.69047 1.28967 8.31718L3.11236 6.55555V4.06198C3.11236 3.53752 3.53752 3.11236 4.06198 3.11236H6.55555L8.31718 1.28967Z",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39145 9C5.39145 7.00705 7.00705 5.39145 9 5.39145C10.993 5.39145 12.6086 7.00705 12.6086 9C12.6086 10.993 10.993 12.6086 9 12.6086C7.00705 12.6086 5.39145 10.993 5.39145 9Z",
    stroke: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInactive);
export default __webpack_public_path__ + "static/media/settings_inactive.88e12b923cc56d163363ac7c0dfbfd37.svg";
export { ForwardRef as ReactComponent };